export const revealGuideTarget = (targetId: string) => {
  const target = document.getElementById(targetId);
  if (!target) return false;

  const scrollContainer = target.closest('.scrollbar-container, .ps') as HTMLElement | null;
  if (!scrollContainer) {
    target.scrollIntoView({ block: 'center' });
    return true;
  }

  const targetBounds = target.getBoundingClientRect();
  const containerBounds = scrollContainer.getBoundingClientRect();
  const targetHeight = targetBounds.height || target.offsetHeight;
  const relativeTop = targetBounds.top - containerBounds.top || target.offsetTop;
  scrollContainer.scrollTop = Math.max(0, scrollContainer.scrollTop + relativeTop - (scrollContainer.clientHeight - targetHeight) / 2);
  scrollContainer.dispatchEvent(new Event('scroll'));
  return true;
};
